import React from "react";
import { Box, Image, Flex, Spinner } from "@chakra-ui/react";
import { PlayIcon } from "./playicon";
import { CertificateIcon } from "./certificate-icon";
import { useTranslation } from "react-i18next";
import {
  CompletedCourseWrapper,
  CourseActionsWrapper,
  RewatchButton,
  CertificateButton,
  CompletedCourseTitle,
  CompletionDateText,
} from "../styles";
import { useCertificateContext } from "@root/context/certificate-context";
import { ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";
import useMediaQ from "@root/hooks/useMediaQ";
import { formatDateToISO } from "@root/utils/date-helper";
import defaultThumbnail from "@root/assets/images/Course Thunbnail.png";
import MobileCompletedCourse from "./MobileCompletedCourse";

const DEFAULT_THUMBNAIL = defaultThumbnail;

const CompletedCourse: React.FC<any> = ({
  courseImage,
  course,
  completedAt,
}) => {
  const { t } = useTranslation("common");
  const { fetchCertificate, isCertificateLoading } = useCertificateContext();
  const navigate = useNavigate();
  const { sm } = useMediaQ();
  const isMobile = !sm;

  if (isMobile) {
    return <MobileCompletedCourse course={course} completedAt={completedAt} />;
  }

  // Desktop version
  const flexDirection = "row";
  return (
    <CompletedCourseWrapper
      as={Flex}
      direction={flexDirection}
      align={{ base: "stretch", md: "center" }}
      gap={{ base: 4, md: 6 }}
      p={{ base: 3, md: 5 }}
      className="single-item-test"
    >
      <Flex flex={1}>
        <Box
          w="180px"
          h="120px"
          flexShrink={0}
          borderRadius="9px"
          overflow="hidden"
        >
          <Image
            src={course?.thumbnail || DEFAULT_THUMBNAIL}
            borderRadius="9"
            w="100%"
            h="100%"
            objectFit="contain"
          />
        </Box>

        <Box display="flex" flexDirection="column" gap={4}>
          <Box
            flex={1}
            px={4}
            display="flex"
            flexDirection="column"
            alignItems={{ base: "flex-start", md: "flex-start" }}
            justifyContent="space-between"
          >
            <CompletedCourseTitle>{course?.title}</CompletedCourseTitle>
            <CompletionDateText my={"12px"}>
              {t("certificateSection.completed")}:{" "}
              {completedAt ? formatDateToISO(completedAt) : "-"}
            </CompletionDateText>
            <Box
              bg="#F0F9F7"
              color="#00A177"
              borderRadius="16px"
              px="12px"
              py="4px"
              fontSize="12px"
              fontWeight="600"
              border="1px solid #00A177"
              w="fit-content"
            >
              {t("course.issued")}
            </Box>
          </Box>
        </Box>
      </Flex>
      <CourseActionsWrapper
        gap={3}
        justify={{ base: "flex-start", md: "flex-end" }}
        align={{ base: "center", md: "center" }}
        w={{ base: "100%", md: "auto" }}
      >
        <>
          <RewatchButton
            onClick={() =>
              navigate(`${ROUTE_NAMES.JOURNALIST_COURSE_DETAIL}/${course?.id}`)
            }
            w={{ base: "auto", sm: "auto" }}
          >
            <PlayIcon boxSize={3} color="#1819B4" />
            {t("certificateSection.Re-watch")}
          </RewatchButton>
          <CertificateButton
            onClick={() =>
              fetchCertificate({
                courseId: course?.id,
                gmtOffset: 0,
              })
            }
            w={{ base: "auto", sm: "auto" }}
            isLoading={isCertificateLoading(course?.id)}
            loadingText={t("certificateSection.download")}
            disabled={isCertificateLoading(course?.id)}
          >
            {isCertificateLoading(course?.id) ? (
              <Spinner size="sm" />
            ) : (
              <CertificateIcon boxSize={4} />
            )}
            {t("certificateSection.download")}
          </CertificateButton>
        </>
      </CourseActionsWrapper>
    </CompletedCourseWrapper>
  );
};

export default CompletedCourse;
